import { render } from "./identityPop.vue?vue&type=template&id=51c7f44d&scoped=true&ts=true"
import script from "./identityPop.vue?vue&type=script&lang=ts"
export * from "./identityPop.vue?vue&type=script&lang=ts"

import "./identityPop.vue?vue&type=style&index=0&id=51c7f44d&lang=scss"
import "./identityPop.vue?vue&type=style&index=1&id=51c7f44d&lang=scss&scoped=true"

import exportComponent from "E:\\bjft\\bjjc-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c7f44d"]])

export default __exports__